import { render, staticRenderFns } from "./Vehiclerecords.vue?vue&type=template&id=3a34cd90&scoped=true&"
import script from "./Vehiclerecords.vue?vue&type=script&lang=js&"
export * from "./Vehiclerecords.vue?vue&type=script&lang=js&"
import style0 from "./Vehiclerecords.vue?vue&type=style&index=0&id=3a34cd90&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a34cd90",
  null
  
)

export default component.exports